// user
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import WebbDividerMedium from "../webb/webb-divider-md";
import WebbSpinner from "../webb/webb-spinner-sm";

import { XGetUserTokens } from "../../services/srvc-tokens-xr";

import avtx from '../../media/user.png'

export default function UserViewCredsModule() {
  
  const {id} = useParams();

  const [loading, setLoading] = useState(true)

  const [cred, setCred] = useState([])
  const [data, setData] = useState([])

  useEffect( () => {
    if (id){
      const fetchData = async() => {

        const result = await XGetUserTokens({
          acnt: id
        })
        
        setData(result)
        setLoading(false)

      }
      fetchData()
    } else {}
  },[id]);


  if (loading) return ( 
    <>
      <WebbDividerMedium />
      <div className="text-center">
        <p className="lead text-center text-color-tone">
          <i className="caption-md bi-grid"></i>
        </p>
        <p className="lead text-color-tone">Loading Your XRPL NFT Credentials</p>
        <WebbSpinner />
      </div>

    </>
  );

  if (data.length===0) return ( 
    <>
      <WebbDividerMedium />
      <p className="lead text-center text-color-tone">
        <i className="caption-md bi-grid"></i>
      </p>
      <p className="lead text-center text-color-tone">
        Unable to find XRPL-NFT Tokens for this account. 
      </p>
      <p className="lead text-center text-color-tone">
        Please request from your Academic, Work Organizations and DAOs. 
      </p>
    </>
  );

  return (
    <>
      <div className="text-center">
        <p className="lead text-center text-color-tone">
          <i className="caption-md bi-briefcase"></i>
        </p>
        <p className="caption-md text-color-main">Your XRPL NFT Credentials</p>
      </div>

      <WebbDividerMedium />
      <div className="container">

        <div className="row row-cols-2 row-cols-md-4">
          {data && data.length>0 && data.map((item, i) => (
            <div className="col mb-3" key={i}>
            
              <a href={item.link} target={'_blank'} >
                <div className="media-square rounded-wd shadow">
                  <img src={item.link} className="rounded-wd img-fluid" alt='...'></img>
                </div>
              </a>
              <div className="pt-3 text-center">
                <h1 className="fw-bold text-primary m-0 d-none">{item.name}</h1>
                <p className="m-0 fw-bold small">ID: {item.TokenID.substring(48)}</p>
                <p className="m-0 text-truncate small">Issuer: {item.Issuer}</p>
                
              </div>
            </div>
          ))}    
        </div>


      </div>

      <WebbDividerMedium />
      <WebbDividerMedium />

    </>
  );

}